<div class="w-full min-h-full px-4">
    <div class="w-full flex flex-column gap-3">
        <h1 class="text-left text-3xl font-medium">Common Questions</h1>
        <div class="w-full flex flex-column gap-3">

            <div *ngFor="let question of commonQuestions; let i = index"
                class="w-full flex flex-column gap-2 p-3 border-1 border-round-xl relative bg-white"
                style="border-color: #E3EBF6;">
                
                <!-- Labels Row -->
                <div class="w-full flex gap-2">
                    <b class="flex-1 text-left text-base font-medium">Question {{i+1}}</b>
                    <b class="w-12rem text-left text-base font-medium">Answer Word Limit</b>
                </div>

                <p-button (onClick)="deleteQuestion(question.id)" icon="pi pi-times" [rounded]="true"
                    styleClass="closeIcon"></p-button>

                <!-- Inputs Row -->
                <div class="w-full flex gap-2">
                    <!-- Question Input -->
                    <input required [(ngModel)]="question.question" type="text" pInputText class="flex-1" />

                    <!-- Answer Word Limit Input -->
                    <input [(ngModel)]="question.answerWordLimit"
                        type="number"
                        pInputText
                        required
                        class="w-12rem"
                        min="1"
                        placeholder="Word Limit"
                        oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                    />
                </div>

                <div class="w-full flex align-items-center justify-content-center mt-2">
                    <p-button type="submit" (onClick)="updateQuestion(question)" label="Save" class="w-full sm:w-12rem"
                        styleClass="save_btn" />
                </div>
            </div>

            <div class="w-full flex align-items-center justify-content-end">
                <p-button (onClick)="addNewQuestion()" label="Add New" class="w-full sm:w-12rem"
                    styleClass="add-new-btn" />
            </div>

        </div>
    </div>
</div>
